import { Button } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';

interface AddFundingLinkProps {
    isDisabled?: boolean;
    onClick: () => void;
}

export function OrganizationContractSettingsAddFundingLink(props: Readonly<AddFundingLinkProps>) {
    const translate = getSelectedLanguage();

    return (
        <Button
            isDisabled={props.isDisabled}
            onClick={props.onClick}
            size="small"
            variant="link"
        >
            {translate.contractSettings.addFundingRecord}
        </Button>
    );
}
